import { render } from "./Tutorials.vue?vue&type=template&id=4e32783f&scoped=true"
import script from "./Tutorials.vue?vue&type=script&lang=js"
export * from "./Tutorials.vue?vue&type=script&lang=js"

import "./Tutorials.vue?vue&type=style&index=0&id=4e32783f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e32783f"]])

export default __exports__